import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { extendObservable } from 'mobx'
import moment from 'moment'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import ArrowBack from '@components/Icon/ArrowBack'
import ArrowForward from '@components/Icon/ArrowForward'
import CloseIcon from '@material-ui/icons/Close'

class MonthYearCalendar extends Component {
  static propTypes = {
    onMonthPress: PropTypes.func,
    activeMonthAndYear: PropTypes.string,
    monthAndYear: PropTypes.string,
    isMonthDisabled: PropTypes.func,
    allowFutureMonthYear: PropTypes.bool,
    earliestYearAllowed: PropTypes.number,
    closeCalendar: PropTypes.func
  }

  constructor(props) {
    super(props)

    extendObservable(this, {
      displayedYear: moment(
        props.monthAndYear ? new Date(props.monthAndYear) : new Date()
      ).year()
    })

    this.months = [
      { id: 1, name: 'Jan' },
      { id: 2, name: 'Feb' },
      { id: 3, name: 'Mar' },
      { id: 4, name: 'Apr' },
      { id: 5, name: 'May' },
      { id: 6, name: 'Jun' },
      { id: 7, name: 'Jul' },
      { id: 8, name: 'Aug' },
      { id: 9, name: 'Sep' },
      { id: 10, name: 'Oct' },
      { id: 11, name: 'Nov' },
      { id: 12, name: 'Dec' }
    ]
  }



  prevYear = () => {
    this.displayedYear = this.displayedYear - 1
  }
  nextYear = () => {
    this.displayedYear = this.displayedYear + 1
  }

  onMonthPress = ({ id, name }) => () => {
    const activeMonthAndYear = this.getMonthYear(id)

    let isDisabled = false
    const { isMonthDisabled, allowFutureMonthYear } = this.props
    if (isMonthDisabled) {
      isDisabled = isMonthDisabled(name, this.displayedYear)
    }
    if (
      allowFutureMonthYear ||
      (activeMonthAndYear.isBefore(moment()) && !isDisabled)
    ) {
      this.props.onMonthPress(activeMonthAndYear, false)
    }
  }

  /**
   * @see https://atheneum-partners.atlassian.net/browse/AP-783
   *
   * Using moment to parse a constructed YYYY-MM like: moment(new Date(`${this.displayedYear}-${id}`))
   * will sometimes flip the month to an unexpected value depending on time zones, therefore
   * set the year / month explicitly. Month is zero-indexed in moment, surprisingly
   */
  getMonthYear = monthNumber =>
    moment()
      .year(this.displayedYear)
      .month(monthNumber - 1)
      .startOf('month')

  renderMonth = month => {
    const {
      isMonthDisabled,
      activeMonthAndYear,
      allowFutureMonthYear
    } = this.props

    const currentMonthYear = this.getMonthYear(month.id)

    const isSelected =
      activeMonthAndYear === currentMonthYear.format('MMM YYYY')

    let isDisabled = currentMonthYear > moment()
    if (isMonthDisabled) {
      isDisabled = isMonthDisabled(month.name, this.displayedYear)

      if (!allowFutureMonthYear) {
        isDisabled = isDisabled || currentMonthYear > moment()
      }
    }

    const classes = classNames({
      monthpicker__month: true,
      'monthpicker__month--selected': isSelected && !isDisabled,
      'monthpicker__month--disabled': isDisabled
    })

    return (
      <li key={month.id} className={classes} onClick={this.onMonthPress(month)}>
        {month.name}
      </li>
    )
  }

  render() {
    const currYear = moment().year()

    return (
      <div className='calendar__wrapper'>
        {this.props.closeCalendar && (
          <div
            onClick={this.props.closeCalendar && this.props.closeCalendar}
            className='calendar-close'
          >
            <CloseIcon />
          </div>
        )}
        <div className='calendar-label'>
          {!(this.displayedYear === this.props.earliestYearAllowed) ? (
            <span className='calendar-label--iconLeft' onClick={this.prevYear}>
              <ArrowBack />
            </span>
          ) : (
            <span className='calendar-label--iconLeft' />
          )}

          <span className='calendar-label--year_display'>
            {this.displayedYear}
          </span>
          {!(this.displayedYear > currYear) && (
            <span className='calendar-label--iconRight' onClick={this.nextYear}>
              <ArrowForward />
            </span>
          )}
        </div>
        <ul className='calendar'>{this.months.map(this.renderMonth)}</ul>
      </div>
    )
  }
}

export default observer(MonthYearCalendar)
